import { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import moment from "moment-timezone";
import Loader from "../layout/Loader";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";
import Pagination from "../layout/Pagination";
import PermissionGate from "../layout/PermissionGate";
import Suspend from "../driver/actions/Suspend";
import Online from "../driver/actions/Online";

const CompanyDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [licenceSize, setLicenceSize] = useState(0);
  const [contractSize, setContractSize] = useState(0);
  const [signatorySize, setSignatorySize] = useState(0);
  const [articleSize, setArticleSize] = useState(0);
  const [popup, setPopup] = useState("");
  const [error, setError] = useState({});
  const [employees, setEmployees] = useState([]);
  const [employee, setEmployee] = useState({});
  const [drivers, setDrivers] = useState([]);
  const [driver, setDriver] = useState({});
  const [driverPage, setDriverPage] = useState(1);
  const [driverCount, setDriverCount] = useState(0);
  const [driverSearch, setDriverSearch] = useState("");
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const driverLimit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchCompanyDetails = () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `delivary-company-details?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async (res) => {
        if (res.data.code === 1) {
          setData(res.data.data);
          if (res?.data?.data?.licencePhoto) {
            setLicenceSize(
              await getFileSize(
                process.env.REACT_APP_API_PUBLIC_URL +
                  res?.data?.data?.licencePhoto
              )
            );
          }
          if (res?.data?.data?.contractPhoto) {
            setContractSize(
              await getFileSize(
                process.env.REACT_APP_API_PUBLIC_URL +
                  res?.data?.data?.contractPhoto
              )
            );
          }
          if (res?.data?.data?.signatoryDocument) {
            setSignatorySize(
              await getFileSize(
                process.env.REACT_APP_API_PUBLIC_URL +
                  res?.data?.data?.signatoryDocument
              )
            );
          }
          if (res?.data?.data?.articlesOfAssociation) {
            setArticleSize(
              await getFileSize(
                process.env.REACT_APP_API_PUBLIC_URL +
                  res?.data?.data?.articlesOfAssociation
              )
            );
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const fetchDrivers = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}all-drivers?page=${driverPage}&limit=${driverLimit}&search=${driverSearch}&delivaryCompanyId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (driverPage > 1) {
            if (res.data.data.length === 0) {
              setDriverPage(driverPage - 1);
            } else {
              setDrivers(res.data.data);
              setDriverCount(res.data.count);
            }
          } else {
            setDrivers(res.data.data);
            setDriverCount(res.data.count);
          }
        }
      })
      .catch(console.error);
  };
  const getFileSize = async (url) => {
    const size = axios
      .head(url)
      .then((res) => {
        let fileSize = res.headers.get("Content-Length");
        if (fileSize) {
          fileSize = (parseInt(fileSize, 10) / 1024).toFixed(2);
        } else {
          fileSize = 0;
        }
        return fileSize;
      })
      .catch((error) => {
        console.log(error);
        return 0;
      });
    return size;
  };
  const fetchEmployees = () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          `all-employees?delivaryCompanyId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setEmployees(res.data.data);
        }
      })
      .catch(console.error);
  };
  const openPopup = (action, data) => {
    switch (action) {
      case "add-employee":
        setEmployee(data);
        break;
      case "edit-employee":
        setEmployee(data);
        break;
      case "reset-password-employee":
        setEmployee(data);
        break;
      case "delete-employee":
        setEmployee(data);
        break;
      case "change-status":
        setDriver(data);
        break;
      case "change-availability":
        setDriver(data);
        break;
      case "reset-driver-password":
        setDriver(data);
        break;
      case "delete-driver":
        setDriver(data);
        break;
      default:
        break;
    }
    setPopup(action);
  };
  const addEmployee = () => {
    const errors = {};
    if (employee.name === undefined || employee.name === "") {
      errors["name"] = "Please Enter Name";
    }
    if (employee.email === undefined || employee.email === "") {
      errors["email"] = "Please Enter Email";
    }
    if (employee.role === undefined || employee.role === "") {
      errors["role"] = "Please Select Role";
    }

    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.email === undefined &&
      errors.role === undefined
    ) {
      axios
        .post(
          process.env.REACT_APP_API_ENDPOINT + "create-employee",
          {
            ...employee,
            merchantId: null,
            delivaryCompanyId: id,
            branchId: null,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setPopup("");
              setError({});
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              fetchEmployees();
            }
          }
        })
        .catch(console.error);
    }
  };
  const editEmployee = () => {
    const errors = {};
    if (employee.name === undefined || employee.name === "") {
      errors["name"] = "Please Enter Name";
    }
    if (employee.email === undefined || employee.email === "") {
      errors["email"] = "Please Enter Email";
    }
    if (employee.role === undefined || employee.role === "") {
      errors["role"] = "Please Select Role";
    }

    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.email === undefined &&
      errors.role === undefined
    ) {
      axios
        .post(process.env.REACT_APP_API_ENDPOINT + "edit-employee", employee, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setPopup("");
              setEmployee({});
              setError({});
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              fetchEmployees();
            }
          }
        })
        .catch(console.error);
    }
  };
  const deleteEmployee = () => {
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "delete-employee", employee, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setEmployee({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchEmployees();
          }
        }
      })
      .catch(console.error);
  };
  const resetPasswordEmployee = () => {
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "reset-password-employee",
        employee,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setEmployee({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchEmployees();
          }
        }
      })
      .catch(console.error);
  };
  const changeDriverAvailability = () => {
    if (driver.id !== undefined && driver?.busy !== undefined) {
      axios
        .patch(
          `${process.env.REACT_APP_API_ENDPOINT}change-driver-availability/${driver?.id}`,
          driver?.busy === true
            ? {
                busy: false,
              }
            : {
                busy: true,
              },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setDriver({});
            fetchDrivers();
            refreshDriverApp(driver?.id);
          }
        })
        .catch(console.error);
    }
  };
  const changeStatusDriver = () => {
    if (driver.id !== undefined && driver.status !== undefined) {
      const status = driver.status === true ? false : true;
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}change-driver-status`,
          {
            id: driver.id,
            status: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setDriver({});
            fetchDrivers();
          }
        })
        .catch(console.error);
    }
  };
  const resetPasswordDriver = () => {
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "reset-password-driver",
        driver,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setDriver({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchDrivers();
          }
        }
      })
      .catch(console.error);
  };
  const deleteDriver = () => {
    if (driver.id !== undefined) {
      axios
        .post(
          `${process.env.REACT_APP_API_ENDPOINT}delete-driver`,
          {
            id: driver.id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setPopup("");
            setDriver({});
            fetchDrivers();
          }
        })
        .catch(console.error);
    }
  };
  useEffect(() => {
    fetchCompanyDetails();
    fetchEmployees();
  }, []);
  useEffect(() => {
    fetchDrivers();
  }, [driverPage, driverSearch]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Company Details
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <div className="d-flex align-items-center">
                  {/*begin::Edit Button*/}
                  <PermissionGate
                    required={`edit_delivery_company`}
                    fallback={<></>}
                  >
                    <Link
                      to={`/delivary-companies/edit-delivary-company/${id}`}
                      className="ms-4 btn btn-color-success bg-body me-3"
                    >
                      <i className="bi-duotone bi-pen"></i>
                      Edit
                    </Link>
                  </PermissionGate>
                  {/*end::Edit Button*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <div className="row g-5 g-lg-10">
                  {/*begin::Card*/}
                  <PermissionGate required={`view_delivery_company_details`}>
                    <div className="card">
                      {/*begin::Card header*/}
                      <div className="card-header border-0 pt-6">
                        {/*begin::Card title*/}
                        <div className="card-title"></div>
                        {/*begin::Card title*/}
                      </div>
                      {/*end::Card header*/}

                      {/*begin::Card body*/}
                      <div className="card-body py-4">
                        <div className="row">
                          <div className="col">
                            <div className="d-flex flex-wrap flex-sm-nowrap">
                              {/*begin: Pic*/}
                              <div className="me-7 mb-4">
                                <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                                  <img
                                    src={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.logo}`}
                                    alt={data?.name}
                                  />
                                </div>
                              </div>
                              {/*end::Pic*/}

                              {/*begin::Info*/}
                              <div className="flex-grow-1">
                                {/*begin::Title*/}
                                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                                  {/*begin::User*/}
                                  <div className="d-flex flex-column">
                                    {/*begin::Name*/}
                                    <div className="d-flex align-items-center mb-2">
                                      <span className="text-primary text-hover-primary fs-2 fw-bold me-1">
                                        {data?.name}
                                      </span>
                                    </div>
                                    {/*end::Name*/}

                                    {/*begin::Info*/}
                                    <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 mt-5 pe-2">
                                      <span className="d-flex align-items-center text-primary me-5 mb-2">
                                        Legal Name
                                      </span>
                                      <span className="d-flex align-items-center text-white-400 mb-2">
                                        {data?.legalName}
                                      </span>
                                    </div>
                                    {/*end::Info*/}
                                  </div>
                                  {/*end::User*/}
                                </div>
                                {/*end::Title*/}
                              </div>
                              {/*end::Info*/}
                            </div>
                          </div>
                          <div className="col">
                            {/*begin::Legal Address*/}
                            <div className="fw-semibold fs-6 mb-4 mt-5 pe-2">
                              <span className="d-flex align-items-center text-primary me-5 mb-2">
                                Legal Address
                              </span>
                              <span className="d-flex align-items-center text-white-400 mb-2">
                                {`${data?.legalArea?.value}, ${data?.legalBlock?.value}, ${data?.legalStreet?.value}`}
                              </span>
                            </div>
                            {/*end::Legal Address*/}
                            {/*begin::Billing Address*/}
                            <div className="fw-semibold fs-6 mb-4 mt-5 pe-2">
                              <span className="d-flex align-items-center text-primary me-5 mb-2">
                                Billing Address
                              </span>
                              <span className="d-flex align-items-center text-white-400 mb-2">
                                {`${data?.billingArea?.value}, ${data?.billingBlock?.value}, ${data?.billingStreet?.value}`}
                              </span>
                            </div>
                            {/*end::Billing Address*/}
                          </div>
                          <div className="col">
                            {/*begin::Default Currency*/}
                            <div className="fw-semibold fs-6 mb-4 mt-5 pe-2">
                              <span className="d-flex align-items-center text-primary me-5 mb-2">
                                Default Currency
                              </span>
                              <span className="badge bg-success text-white-400 text-light ">
                                <span className="d-flex align-items-center text-white-400">
                                  {data?.defaultCurrency}
                                </span>
                              </span>
                            </div>
                            {/*end::Default Currency*/}
                            {/*begin::Licence Expiary*/}
                            <div className="fw-semibold fs-6 mb-4 mt-5 pe-2">
                              <span className="d-flex align-items-center text-primary me-5 mb-2">
                                Licence Expiary
                              </span>
                              <span className="d-flex align-items-center text-white-400 mb-2">
                                {moment(data?.licenseExpiary)
                                  .tz(process.env.REACT_APP_TIMEZONE)
                                  .format("Do MMM, YYYY")}
                              </span>
                            </div>
                            {/*end::Licence Expiary*/}
                          </div>
                        </div>
                        <div className="overflow-auto pb-5">
                          <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-5">
                            {/*begin::Licence*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              {/*begin::Icon*/}
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/certificate.png"
                                }
                              />
                              {/*end::Icon*/}

                              {/*begin::Licence*/}
                              <div className="ms-1 fw-semibold">
                                {/*begin::Desc*/}
                                <a
                                  href={`${process.env.REACT_APP_API_PUBLIC_URL}${data?.licensePhoto}`}
                                  className="d-flex align-items-center text-white-400 mb-2"
                                  target="_blank"
                                  download
                                >
                                  Company Licence
                                </a>
                                {/*end::Desc*/}
                                {/*begin::Number*/}
                                <div className="text-gray-400">
                                  {licenceSize} KB
                                </div>
                                {/*end::Number*/}
                              </div>
                              {/*begin::Licence*/}
                            </div>
                            {/*end::Licence*/}

                            {/*begin::Contract*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              {/*begin::Icon*/}
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/compliant.png"
                                }
                              />
                              {/*end::Icon*/}

                              {/*begin::Licence*/}
                              <div className="ms-1 fw-semibold">
                                {/*begin::Desc*/}
                                <a
                                  href="{{ $company->contract_photo }}"
                                  className="fs-6 text-hover-primary fw-bold"
                                  download
                                >
                                  Contract Paper
                                </a>
                                {/*end::Desc*/}
                                {/*begin::Number*/}
                                <div className="text-gray-400">
                                  {contractSize} kb
                                </div>
                                {/*end::Number*/}
                              </div>
                              {/*begin::Licence*/}
                            </div>
                            {/*end::Contract*/}

                            {/*begin::Signatory*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/contract.png"
                                }
                              />
                              <div className="ms-1 fw-semibold">
                                <a
                                  href="{{ $company->signatory_document }}"
                                  className="fs-6 text-hover-primary fw-bold"
                                  download
                                >
                                  Signatory Document
                                </a>
                                <div className="text-gray-400">
                                  {signatorySize} kb
                                </div>
                              </div>
                            </div>
                            {/*end::Signatory*/}

                            {/*begin::Article*/}
                            <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                              <img
                                alt=""
                                className="w-40px me-3"
                                src={
                                  process.env.REACT_APP_PUBLIC_URL +
                                  "icons/paper.png"
                                }
                              />
                              <div className="ms-1 fw-semibold">
                                <a
                                  href="{{ $company->articles_of_association }}"
                                  className="fs-6 text-hover-primary fw-bold"
                                  download
                                >
                                  Article of Association{" "}
                                </a>
                                <div className="text-gray-400">
                                  {articleSize} kb
                                </div>
                              </div>
                            </div>
                            {/*end::Article*/}
                          </div>
                        </div>
                      </div>
                      {/*end::Card body*/}
                    </div>
                  </PermissionGate>
                  {/*end::Card*/}
                </div>

                {/*begin::Drivers Row*/}
                <div className="row g-5 g-lg-10 mt-4">
                  {/*begin::Col*/}
                  <div className="col ps-0 mb-xl-10" id="loadCompanyDrivers">
                    <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                      Drivers
                    </h1>
                    {/*begin::Tables Widget 3*/}
                    <PermissionGate
                      required={`view_delivery_company_driver_list`}
                    >
                      <div className="card">
                        {/*begin::Card header*/}
                        <div className="card-header border-0 pt-6">
                          {/*begin::Search*/}
                          <div className="w-100 my-1">
                            <input
                              type="text"
                              value={driverSearch}
                              autoComplete="off"
                              onChange={(e) => {
                                setDriverSearch(e.target.value);
                              }}
                              id="searchDriverInput"
                              className="form-control w-100"
                              placeholder="Search Driver Name, Phone"
                            />
                          </div>
                          {/*end::Search*/}
                        </div>
                        {/*end::Card header*/}

                        {/*begin::Card body*/}
                        <div
                          className="card-body py-4 text-center"
                          id="filterDataWrap"
                        >
                          {/*begin::Table*/}
                          {drivers?.length === 0 ? (
                            <div className="text-center w-100">
                              <img
                                className="w-25 mx-auto py-20"
                                src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                                alt="no-content"
                              />
                            </div>
                          ) : (
                            <div className="table-responsive">
                              <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                  <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                    <th className="text-center min-w-100px">
                                      Profile Image
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Driver Name
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Sharing
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Availability
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Location Updated
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Phone Number
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Status
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold">
                                  {drivers?.map((item, index) => {
                                    return (
                                      <tr key={index} className="text-center">
                                        <td>
                                          {/*begin:: Avatar */}
                                          <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                            <Link
                                              to={`/drivers/driver-details/${item?._id}`}
                                            >
                                              <div className="symbol-label">
                                                <img
                                                  src={`${process.env.REACT_APP_API_PUBLIC_URL}${item?.profilePhoto}`}
                                                  alt={item?.name}
                                                  className="w-100"
                                                />
                                              </div>
                                            </Link>
                                          </div>
                                          {/*end::Avatar*/}
                                        </td>
                                        <td>
                                          {/*begin::User details*/}
                                          <div className="d-flex">
                                            <Link
                                              to={`/drivers/driver-details/${item?._id}`}
                                              className="text-gray-800 text-hover-primary"
                                            >
                                              {item?.name}
                                            </Link>
                                          </div>
                                          {/*begin::User details*/}
                                        </td>
                                        <td>---</td>
                                        <td>
                                          <div className="badge badge-success fw-bold">
                                            Available
                                          </div>
                                        </td>
                                        <td>3 seconds ago</td>
                                        <td>{item?.workPhone}</td>
                                        <td>
                                          <span
                                            className={
                                              item?.status === true
                                                ? "badge bg-success text-light"
                                                : "badge bg-danger text-light"
                                            }
                                          >
                                            {item?.status === true
                                              ? "Active"
                                              : "Suspended"}
                                          </span>
                                        </td>
                                        <td className="">
                                          <div className="btn-group">
                                            {/*begin::View*/}
                                            <PermissionGate
                                              required={`view_driver_details`}
                                              fallback={<></>}
                                            >
                                              <Link
                                                to={`/drivers/driver-details/${item?._id}`}
                                                className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
                                                title="Show Details"
                                              >
                                                <i className="bi-duotone bi-eye fs-5"></i>
                                              </Link>
                                            </PermissionGate>
                                            {/*end::View*/}
                                            {/*begin::Edit*/}
                                            <PermissionGate
                                              required={`edit_driver_details`}
                                              fallback={<></>}
                                            >
                                              <Link
                                                to={`/drivers/edit-driver/${item?._id}`}
                                                className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                                title="Edit"
                                              >
                                                <i className="bi-duotone bi-pen fs-5"></i>
                                              </Link>
                                            </PermissionGate>
                                            {/*end::Edit*/}
                                            {/*begin::Suspend*/}
                                            <Suspend
                                              openPopup={openPopup}
                                              item={item}
                                            />
                                            {/*end::Suspend*/}
                                            {/*begin::Online*/}
                                            <Online
                                              id={item?._id}
                                              openPopup={openPopup}
                                              busy={item?.busy}
                                            />
                                            {/*end::Online*/}
                                            {/*begin::Change Password*/}
                                            <PermissionGate
                                              required={`reset_driver_password`}
                                              fallback={<></>}
                                            >
                                              <span
                                                onClick={() => {
                                                  openPopup(
                                                    "reset-driver-password",
                                                    item
                                                  );
                                                }}
                                                className="btn px-2 btn-outline btn-info btn-color-white btn-sm"
                                                title="Reset Password"
                                              >
                                                <i className="bi-duotone bi-key fs-5"></i>
                                              </span>
                                            </PermissionGate>
                                            {/*end::Change Password*/}

                                            {/*begin::Delete*/}
                                            <PermissionGate
                                              required={`delete_driver`}
                                              fallback={<></>}
                                            >
                                              <span
                                                onClick={() => {
                                                  openPopup("delete-driver", {
                                                    id: item._id,
                                                  });
                                                }}
                                                className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                                title="Delete Driver"
                                              >
                                                <i className="bi-duotone bi-trash fs-5"></i>
                                              </span>
                                            </PermissionGate>

                                            {/*end::Delete*/}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                              {/* start :: Change Status */}
                              <div
                                className={
                                  popup === "change-status"
                                    ? "modal fade show d-block"
                                    : "modal fade"
                                }
                                tabIndex={-1}
                                id="kt_modal_1"
                              >
                                <div className="modal-dialog modal-dialog-centered modal-sm">
                                  <div className="modal-content text-center bg-warning text-light">
                                    <div className="modal-header">
                                      <h5 className="modal-title mx-auto text-light">
                                        CHANGE STATUS
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <p className="h4 text-light">
                                        Are You Sure ?
                                      </p>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                      <button
                                        onClick={() => {
                                          setDriver({});
                                          setPopup("");
                                        }}
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        data-bs-dismiss="modal"
                                      >
                                        No
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        onClick={changeStatusDriver}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* end :: Change Status */}
                              {/* start :: Change Availability */}
                              <div
                                className={
                                  popup === "change-availability"
                                    ? "modal fade show d-block"
                                    : "modal fade"
                                }
                                tabIndex={-1}
                              >
                                <div className="modal-dialog modal-dialog-centered modal-sm">
                                  <div className="modal-content text-center bg-warning text-light">
                                    <div className="modal-header">
                                      <h5 className="modal-title mx-auto text-light">
                                        CHANGE AVAILABILITY
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <p className="h4 text-light">
                                        Are You Sure ?
                                      </p>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                      <button
                                        onClick={() => {
                                          setDriver({});
                                          setPopup("");
                                        }}
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        data-bs-dismiss="modal"
                                      >
                                        No
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        onClick={changeDriverAvailability}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* end :: Change Availability */}
                              {/* start :: Reset Password */}
                              <div
                                className={
                                  popup === "reset-driver-password"
                                    ? "modal fade show d-block"
                                    : "modal fade"
                                }
                                tabIndex={-1}
                                id="kt_modal_1"
                              >
                                <div className="modal-dialog modal-dialog-centered modal-sm">
                                  <div className="modal-content text-center bg-info text-light">
                                    <div className="modal-header">
                                      <h5 className="modal-title mx-auto text-light">
                                        RESET PASSWORD
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <p className="h4 text-light">
                                        Are You Sure ?
                                      </p>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                      <button
                                        onClick={() => {
                                          setDriver({});
                                          setPopup("");
                                        }}
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        data-bs-dismiss="modal"
                                      >
                                        No
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        onClick={resetPasswordDriver}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* end :: Reset Password */}
                              {/* start :: delete */}
                              <div
                                className={
                                  popup === "delete-driver"
                                    ? "modal fade show d-block"
                                    : "modal fade"
                                }
                                tabIndex={-1}
                                id="kt_modal_1"
                              >
                                <div className="modal-dialog modal-dialog-centered modal-sm">
                                  <div className="modal-content text-center bg-danger text-light">
                                    <div className="modal-header">
                                      <h5 className="modal-title mx-auto text-light">
                                        DELETE
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <p className="h4 text-light">
                                        Are You Sure ?
                                      </p>
                                    </div>
                                    <div className="modal-footer justify-content-center">
                                      <button
                                        onClick={() => {
                                          setDriver({});
                                          setPopup("");
                                        }}
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        data-bs-dismiss="modal"
                                      >
                                        No
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        onClick={deleteDriver}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* end :: delete */}
                            </div>
                          )}
                          {/*end::Table*/}
                          {/*begin::Paginate*/}
                          {driverCount &&
                          Math.ceil(driverCount / driverLimit) > 1 ? (
                            <Pagination
                              page={driverPage}
                              setPage={setDriverPage}
                              count={driverCount}
                              limit={driverLimit}
                            />
                          ) : (
                            ""
                          )}
                          {/*begin::Paginate*/}
                        </div>
                        {/*end::Card body*/}
                      </div>
                    </PermissionGate>
                  </div>
                  {/*end::Col*/}
                </div>
                {/*end::Drivers Row*/}

                {/*begin::Employees Row*/}
                <div className="row g-5 g-lg-10 mt-4">
                  {/*begin::Col*/}
                  <div className="col ps-0 mb-xl-10" id="loadEmployees">
                    <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                      Employees
                    </h1>
                    {/*begin::Tables Widget 3*/}
                    <PermissionGate
                      required={`view_delivery_company_employees`}
                    >
                      <div className="card">
                        {/*begin::Body*/}
                        <div className="card-body">
                          {/* @if ($employees->count() > 0) */}
                          {employees && employees.length > 0 ? (
                            <div className="table-responsive">
                              <table className="table align-middle table-row-dashed fs-6 gy-5">
                                <thead>
                                  <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                    <th className="text-center min-w-100px">
                                      Name
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Email
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Role
                                    </th>
                                    <th className="text-center min-w-100px">
                                      Created At
                                    </th>

                                    <th className="text-center min-w-100px">
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold">
                                  {employees &&
                                    employees.map((employee, index) => {
                                      return (
                                        <tr key={index} className="text-center">
                                          <td>{employee?.name}</td>
                                          <td>{employee?.email}</td>
                                          <td>{employee?.role}</td>
                                          <td>
                                            {moment(employee?.createdAt)
                                              .tz(
                                                process.env.REACT_APP_TIMEZONE
                                              )
                                              .format("Do MMM, YYYY")}
                                          </td>

                                          <td className="">
                                            <div className="btn-group">
                                              {/*begin::Edit*/}
                                              <PermissionGate
                                                required={`edit_delivery_company_employees`}
                                                fallback={<></>}
                                              >
                                                <button
                                                  onClick={() => {
                                                    openPopup(
                                                      "edit-employee",
                                                      employee
                                                    );
                                                  }}
                                                  className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                                  title="Edit Employee"
                                                >
                                                  <i className="bi-duotone bi-pen fs-5"></i>
                                                </button>
                                              </PermissionGate>
                                              {/*end::Edit*/}
                                              {/*begin::Reset Password*/}
                                              <PermissionGate
                                                required={`reset_password_delivery_company_employees`}
                                                fallback={<></>}
                                              >
                                                <button
                                                  onClick={() => {
                                                    openPopup(
                                                      "reset-password-employee",
                                                      employee
                                                    );
                                                  }}
                                                  className="btn px-2 btn-outline btn-warning btn-color-white btn-sm"
                                                  data-bs-toggle="tooltip"
                                                  data-bs-placement="top"
                                                  title="Reset Password"
                                                >
                                                  <i className="bi-duotone bi-key fs-5"></i>
                                                </button>
                                              </PermissionGate>
                                              {/*end::Reset Password*/}
                                              {/*begin::Delete*/}
                                              <PermissionGate
                                                required={`delete_delivery_company_employees`}
                                                fallback={<></>}
                                              >
                                                <button
                                                  onClick={() => {
                                                    openPopup(
                                                      "delete-employee",
                                                      employee
                                                    );
                                                  }}
                                                  className="btn px-2 btn-outline btn-danger btn-color-white btn-sm"
                                                  title="Delete Employee"
                                                >
                                                  <i className="bi-duotone bi-trash fs-5"></i>
                                                </button>
                                              </PermissionGate>
                                              {/*end::Delete*/}
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-center w-100">
                              <img
                                className="w-25 mx-auto py-20"
                                src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                                alt="no-content"
                              />
                            </div>
                          )}
                          <PermissionGate
                            required={`add_delivery_company_employees`}
                            fallback={<></>}
                          >
                            <button
                              onClick={() => {
                                openPopup("add-employee", {});
                              }}
                              className="btn btn-success btn-sm w-100 me-3"
                            >
                              Add
                            </button>
                          </PermissionGate>
                        </div>
                        {/*begin::Body*/}
                      </div>
                    </PermissionGate>
                    {/*end::Tables Widget 3*/}
                    {/*begin::Modal - Add Employee */}
                    {popup && popup === "add-employee" ? (
                      <div
                        className="modal fade show d-block"
                        id="addEmployeeModal"
                        tabIndex="-1"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded">
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Close*/}
                              <h4>Add Employee</h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <div className="row">
                                <div className="col">
                                  <label className="form-label required">
                                    Name
                                  </label>
                                  <input
                                    value={employee?.name ?? ""}
                                    onChange={(e) => {
                                      setEmployee({
                                        ...employee,
                                        name: e.target.value,
                                      });
                                      setError({ ...error, name: "" });
                                    }}
                                    id="employee_name"
                                    className="form-control"
                                    placeholder="Employee Name"
                                    autoComplete="off"
                                  />
                                  {error.name !== undefined &&
                                  error.name !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.name}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="col">
                                  <label className="form-label required">
                                    Email
                                  </label>
                                  <input
                                    value={employee?.email ?? ""}
                                    onChange={(e) => {
                                      setEmployee({
                                        ...employee,
                                        email: e.target.value,
                                      });
                                      setError({ ...error, email: "" });
                                    }}
                                    id="employee_email"
                                    className="form-control"
                                    placeholder="Employee Email"
                                    autocomplete="off"
                                  />
                                  {error.email !== undefined &&
                                  error.email !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.email}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col">
                                  <label className="form-label required">
                                    Role
                                  </label>
                                  {/*begin::Input group*/}
                                  <div className="row mb-0 text-start">
                                    {/*begin::Input group*/}
                                    <div className="mb-5">
                                      <Select
                                        className="react-select-styled react-select-bordered"
                                        classNamePrefix="react-select"
                                        defaultInputValue={employee?.role ?? ""}
                                        onChange={(e) => {
                                          setEmployee({
                                            ...employee,
                                            role: e.value,
                                          });
                                          setError({ ...error, role: "" });
                                        }}
                                        options={[
                                          {
                                            value: "Employee",
                                            label: "Employee",
                                          },
                                          {
                                            value: "Owner",
                                            label: "Owner",
                                          },
                                          {
                                            value: "Manager",
                                            label: "Manager",
                                          },
                                          {
                                            value: "Accountant",
                                            label: "Accountant`",
                                          },
                                        ]}
                                        placeholder="Select an option"
                                      />
                                    </div>
                                    {/*end::Input group*/}
                                  </div>
                                  {/*end::Input group*/}
                                  {error.role !== undefined &&
                                  error.role !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.role}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              {/*begin::Actions*/}
                              <div className="d-flex flex-row-fluid pt-12">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary me-3"
                                  onClick={() => {
                                    setPopup("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  onClick={addEmployee}
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                >
                                  Save
                                </button>
                              </div>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                    ) : (
                      ""
                    )}
                    {/*end::Modal - Add Employee*/}
                    {/*begin::Modal - Edit Employee*/}
                    {popup && popup === "edit-employee" ? (
                      <div
                        className="modal fade show d-block"
                        id="editEmployeeModal"
                        tabIndex="-1"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded">
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Close*/}
                              <h4>Edit Employee</h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <div className="row">
                                <div className="col">
                                  <label className="form-label required">
                                    Name
                                  </label>
                                  <input
                                    value={employee?.name ?? ""}
                                    onChange={(e) => {
                                      setEmployee({
                                        ...employee,
                                        name: e.target.value,
                                      });
                                      setError({ ...error, name: "" });
                                    }}
                                    id="employee_name"
                                    className="form-control"
                                    placeholder="Employee Name"
                                    autoComplete="off"
                                  />
                                  {error.name !== undefined &&
                                  error.name !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.name}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="col">
                                  <label className="form-label required">
                                    Email
                                  </label>
                                  <input
                                    value={employee?.email ?? ""}
                                    onChange={(e) => {
                                      setEmployee({
                                        ...employee,
                                        email: e.target.value,
                                      });
                                      setError({ ...error, email: "" });
                                    }}
                                    id="employee_email"
                                    className="form-control"
                                    placeholder="Employee Email"
                                    autocomplete="off"
                                  />
                                  {error.email !== undefined &&
                                  error.email !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.email}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col">
                                  <label className="form-label required">
                                    Role
                                  </label>
                                  {/*begin::Input group*/}
                                  <div className="row mb-0 text-start">
                                    {/*begin::Input group*/}
                                    <div className="mb-5">
                                      <Select
                                        className="react-select-styled react-select-bordered"
                                        classNamePrefix="react-select"
                                        defaultValue={
                                          employee?.role
                                            ? {
                                                value: employee.role,
                                                label: employee.role,
                                              }
                                            : null
                                        }
                                        onChange={(e) => {
                                          setEmployee({
                                            ...employee,
                                            role: e.value,
                                          });
                                          setError({ ...error, role: "" });
                                        }}
                                        options={[
                                          {
                                            value: "Employee",
                                            label: "Employee",
                                          },
                                          {
                                            value: "Owner",
                                            label: "Owner",
                                          },
                                          {
                                            value: "Manager",
                                            label: "Manager",
                                          },
                                          {
                                            value: "Accountant",
                                            label: "Accountant",
                                          },
                                        ]}
                                        placeholder="Select an option"
                                      />
                                    </div>
                                    {/*end::Input group*/}
                                  </div>
                                  {/*end::Input group*/}
                                  {error.role !== undefined &&
                                  error.role !== "" ? (
                                    <small className="text-danger mt-2">
                                      {error.role}
                                    </small>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              {/*begin::Actions*/}
                              <div className="d-flex flex-row-fluid pt-12">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary me-3"
                                  onClick={() => {
                                    setPopup("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  onClick={editEmployee}
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                >
                                  Update
                                </button>
                              </div>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                    ) : (
                      ""
                    )}
                    {/*end::Modal - Edit Employee*/}
                    {/*begin::Modal - Delete Employee*/}
                    {popup && popup === "delete-employee" ? (
                      <div
                        className="modal fade show d-block"
                        id="deleteEmployeeModal"
                        tabIndex="-1"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded">
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Close*/}
                              <h4>Delete Employee</h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <h4 className="text-center my-5 text-danger">
                                Are You Sure ?
                              </h4>

                              {/*begin::Actions*/}
                              <div className="d-flex flex-row-fluid pt-3">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary me-3"
                                  onClick={() => {
                                    setEmployee({});
                                    setError({});
                                    setPopup("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  onClick={deleteEmployee}
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  id="kt_modal_upgrade_plan_btn"
                                >
                                  {/*begin::Indicator label*/}
                                  <span className="indicator-label">
                                    Delete
                                  </span>
                                  {/*end::Indicator label*/}
                                  {/*end::Indicator progress*/}
                                </button>
                              </div>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                    ) : (
                      ""
                    )}
                    {/*end::Modal - Delete Employee*/}
                    {/*begin::Modal - Reset Employee Password */}
                    {popup && popup === "reset-password-employee" ? (
                      <div
                        className="modal fade show d-block"
                        id="resetEmployeePasswordModal"
                        tabIndex="-1"
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered">
                          {/*begin::Modal content*/}
                          <div className="modal-content rounded">
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Close*/}
                              <h4>Reset Password</h4>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}

                            {/*begin::Modal body*/}
                            <div className="modal-body p-4">
                              <h4 className="text-center my-5 text-danger">
                                Are You Sure ?
                              </h4>

                              {/*begin::Actions*/}
                              <div className="d-flex flex-row-fluid pt-3">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-secondary me-3"
                                  onClick={() => {
                                    setEmployee({});
                                    setError({});
                                    setPopup("");
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  onClick={resetPasswordEmployee}
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  id="kt_modal_upgrade_plan_btn"
                                >
                                  {/*begin::Indicator label*/}
                                  <span className="indicator-label">
                                    Reset Password
                                  </span>
                                  {/*end::Indicator label*/}
                                  {/*end::Indicator progress*/}
                                </button>
                              </div>
                              {/*end::Actions*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                    ) : (
                      ""
                    )}

                    {/*end::Modal - Reset Employee Password*/}
                  </div>
                  {/*end::Col*/}
                </div>
                {/*end::Employees Row*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/* start :: Change Status */}
          <div
            className={
              popup === "change-status-driver"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    CHANGE STATUS
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setDriver({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={changeStatusDriver}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: Change Status */}
          {/* start :: Reset Password */}
          <div
            className={
              popup === "reset-password-driver"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-warning text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">
                    RESET PASSWORD
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setDriver({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={resetPasswordDriver}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: Reset Password */}
          {/* start :: delete */}
          <div
            className={
              popup === "delete-driver"
                ? "modal fade show d-block"
                : "modal fade"
            }
            tabIndex={-1}
            id="kt_modal_1"
          >
            <div className="modal-dialog modal-dialog-centered modal-sm">
              <div className="modal-content text-center bg-danger text-light">
                <div className="modal-header">
                  <h5 className="modal-title mx-auto text-light">DELETE</h5>
                </div>
                <div className="modal-body">
                  <p className="h4 text-light">Are You Sure ?</p>
                </div>
                <div className="modal-footer justify-content-center">
                  <button
                    onClick={() => {
                      setDriver({});
                      setPopup("");
                    }}
                    type="button"
                    className="btn btn-light btn-sm"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    onClick={deleteDriver}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* end :: delete */}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default CompanyDetails;
